export default __webpack_public_path__ + "static/media/avatar_tommy3.95ffcc0a.mp3";